
import React, { useState } from "react";
import { useDropzone } from "react-dropzone";
import { Button } from '@/atoms';
import { ButtonVariant } from '@/atoms/button/types';
import { Close } from '@/icons';
import { MoonLoader } from "react-spinners";
import { FileUploadIcon } from "@/icons/FileUploadIcon";

interface FileUploadProps {
    setFilesId,
    filesId,
    setFieldTouched
}
export function FileUpload({
    setFilesId,
    filesId,
}: FileUploadProps) {

    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [filesError, setFilesError] = useState(false);

    const onDrop = async (acceptedFiles) => {
        if (uploadedFiles.length <= 4 && uploadedFiles.length + acceptedFiles.length <= 4) {
            acceptedFiles.map(file => {
                setLoading(true);
                const formData = new FormData();
                formData.append("file", file);

                fetch(`/api/upload-file?filename=${file.name}`, {
                    method: "POST",
                    body: formData,
                }).then((response) => response.json().then((json) => {
                    if (response.ok) {
                        setFilesId(filesId => [...filesId, json.fid[0].value]);
                        setUploadedFiles(files => [...files, {
                            fileName: file.name,
                            fileId: json.fid[0].value,
                        }]);
                        setError(false);
                    } else {
                        throw new Error('Error al subir el archivo');
                    }
                })).catch(() => {
                    setError(true);
                }).finally(() => {
                    setLoading(false);
                    setFilesError(false);
                });

            });
        } else {
            setFilesError(true)
        }
    }

    const { getRootProps, getInputProps, fileRejections } = useDropzone({
        accept: {
            "image/*": [".jpeg", ".jpg", ".png"],
            "application/pdf": [".pdf"],
        },
        onDrop,
        maxSize: 5242880,
    });

    function removeFile(file) {
        const newFiles = [...uploadedFiles];
        newFiles.splice(newFiles.indexOf(file), 1);
        const arrayIds = [...filesId];
        arrayIds.splice(arrayIds.indexOf(file.fileId), 1);
        setUploadedFiles(newFiles);
        setFilesId(arrayIds);
        if (newFiles.length <= 4) {
            setFilesError(false);
        }
    }

    return (
        !loading ?
            <div>
                <div {...getRootProps()} className="input-area inline-block mb-4">
                    <div className="flex gap-4 items-center">
                        <div className="min-w-[150px]">
                            <Button as="a" variant={ButtonVariant.ICON}
                            >
                                <FileUploadIcon width={15} height={15} color="#fff" />
                                Subir archivos
                            </Button>
                        </div>
                        <span className="text-body text-body--s mt-2 uppercase">Es necesario adjuntar una fotografía, esto nos permitirá ayudarte mejor.</span>
                    </div>
                    <input {...getInputProps()} />

                    {fileRejections.length > 0 || error || filesError ?
                        <div className="flex flex-col gap-2 mt-2">
                            {fileRejections.length > 0 || error ?
                                <span className="text-body text-body--s text-tertiary-500">
                                    Los archivos tienen que ser de tipo pdf, png, jpg o jpeg y el tamaño máximo es de 5MB
                                </span>
                                : null}
                            {filesError ?
                                <span className="text-body text-body--s text-tertiary-500">
                                    El numero máximo de archivos permitido es de 4
                                </span>
                                : null}
                        </div> : null}
                </div>

                <div>
                    {uploadedFiles.length > 0 ? uploadedFiles.map((file, index) => (
                        <div key={index} className="flex items-center gap-2">
                            <div className="flex items-center bg-neutral-2 py-1 pl-2 pr-4 gap-2 font-manrope text-neutral-8 text-sm leading-5 rounded-lg">
                                {file.fileName} </div>
                            <div onClick={() => removeFile(file)}>
                                <Close width={20} height={20} className="cursor-pointer" />
                            </div>
                        </div>
                    )) : null}
                </div>
            </div >
            :
            <MoonLoader color="#fcba03" speedMultiplier={0.6} className="mx-auto" />
    );
}
